export const formActionTypes = {
  //For Edit Button Click
  SET_EDIT_FORM: "SET_EDIT_FORM",
  SET_EDIT_FORM_SECOND: "SET_EDIT_FORM_SECOND",
};
